import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../assets/scss/pages/coursedetails.scss";

import TrainingCourseBanner from "../../components/TrainingCourseBanner";
import { FaAngleDown, FaDesktop } from "react-icons/fa";
import AccordionComponent from "../../components/AccordionPage";

import AsideBoxWrapper from "../../components/AsideBoxWrapper";
import RequestMoreInformation from "../../components/RequestMoreInformation";
import ReviewCard from "../../components/ReviewsCard";
import CourseSlider from "../../components/CourseSlider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { ratings } from "../../data/courses-data/Ratings";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllCourses } from "../../store2/features/coursesSlice";
import Loader from "../../features/Loader";
import PageLoader from "../../features/PageLoader";
import { Helmet } from "react-helmet";
import SectionHeader from "../../components/SectionHeader";
import { toast } from "react-toastify";
import { addToCart, fetchCartItems } from "../../store2/features/cartSlice";
import { FaCartArrowDown } from "react-icons/fa6";
import { useScroll } from "../../router/Scroll/ScrollContext";
import { callAlert } from "../../services/CommonService";
import {
  setAddToCartDetails,
  setTrailDetails,
  subscriptionTrial,
} from "../../services/AuthService";

export default function TrainingCourse() {
  const { id } = useParams();

  const [course, setCourse] = useState();

  const [error, setError] = useState(null);

  // const [selectedCourse, setSelectedCourse] = useState("Custom Course");
  const [selectedCourse, setSelectedCourse] = useState("Full Course");

  const [selectedCount, setSelectedCount] = useState();

  const [customModules, setCustomModule] = useState(false);

  const [customModuleList, setCustomModuleList] = useState();

  const [totalPrice, setTotalPrice] = useState();

  const [loader, setLoader] = useState(true);

  const { scrollToSection } = useScroll();

  const dispatch = useDispatch();
  // const cartItems = useSelector((state) => state.cart.items);
  const { courses } = useSelector((state) => state.courses);

  const notify = () =>
    toast.success(
      <>
        {course?.courseName} <strong>added to cart</strong>
      </>,
    );
  const selectModule = () =>
    toast.warn(
      <>
        <strong>Select at least one module</strong>
      </>,
    );

  // const [courseModules, setCourseModules] = useState();

  const navigate = useNavigate();

  const [visibleItems, setVisibleItems] = useState(3); // State to track the number of visible items

  const loadMoreItems = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 3); // Increase the number of visible items by 6
  };

  const handleCourseChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCourse(selectedValue);

    if (selectedValue === "Full Course") {
      setCustomModule(true);
    } else {
      setCustomModule(false);
    }
  };

  const userDetailss = localStorage.getItem("userDetails");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiService.publicPostRequest(
          "/courses/findcourses",
          [id],
        );
        setLoader(true);
        setCourse(response.data[0]);

        const isDesktop = window.innerWidth >= 1024; // adjust as needed
        if (isDesktop) {
          setTimeout((d) => {
            const hash = window.location.hash;
            if (hash) {
              const element = document.getElementById(hash.replace("#", ""));
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }
          }, 1000);
        } else {
          setTimeout((d) => {
            const hash = window.location.hash;
            if (hash) {
              const element = document.getElementById(hash.replace("#", ""));
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }, 1000);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setError({
          message: "Course not found",
          url: window.location.href,
        });
      }
      setLoader(false);
    };

    fetchData();
  }, [id]);

  // useEffect(() => {
  //   if (course) {
  //     const fetchModules = async () => {
  //       try {
  //         const moduleIds = course.modules.map(module => module.id);
  //         const modulePromises = moduleIds.map(id =>
  //           ApiService.publicGetRequest(`/course-module/findmodule?moduleId=${id}`)
  //         );

  //         const moduleResponses = await Promise.all(modulePromises);
  //         const modules = moduleResponses.map(response => response.data);
  //         setCourseModules(modules); // Assuming each response.data contains module info
  //       } catch (error) {
  //         console.error('Error fetching modules:', error);
  //         setError({
  //           message: "Modules not found",
  //           url: window.location.href
  //         });
  //       }
  //     };

  //     fetchModules();
  //   }
  // }, [course]);

  // console.log("printing throug clg", error)

  // const { courses, status, errors } = useSelector((state) => state.courses);
  // useEffect(() => {
  //   dispatch(fetchAllCourses());
  //   console.log(courses, "Store courses");
  // }, [dispatch]);

  useEffect(() => {
    if (error) {
      navigate("/custom-error", { state: { error: error && error } });
    }
  }, [error, navigate]);

  const handleAddToCart = async () => {
    console.log(userDetailss, "user details---------------------------------");
    if (!userDetailss) {
      if (selectedCourse === "Custom Course") {
        setAddToCartDetails({
          modeClass: { courseId: course.id, moduleList: customModuleList },
        });
      } else {
        const moduleList = course.modules.map((module) => module.id);
        setAddToCartDetails({
          modeClass: { courseId: course.id, moduleList: moduleList },
        });
      }

      toast.error(
        <>
          Please <strong>login first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      //const isCourseInCart = cartItems?.some(item => item.id === course.id);
      /* if (isCourseInCart) {
        // If the course is already in the cart, display an error toast
        toast.error(
          <>
            {course?.courseName} <strong>is already in the cart</strong>
          </>, { theme: "colored" });
      } else {
        // If the course is not in the cart, dispatch the addToCart action and display a success toast
     
        notify();
      } */
      if (selectedCourse === "Custom Course") {
        if (customModuleList.length > 0) {
          scrollToSection("top");
          const result = await dispatch(
            addToCart({ courseId: course.id, moduleList: customModuleList }),
          );

          if (result.payload?.resultCode != 1) {
            callAlert("", result.payload?.message);

            return;
          }

          dispatch(fetchCartItems());
          notify();
          const timeoutId = setTimeout(() => {
            navigate("/cart");
          }, 2000);
          return () => clearTimeout(timeoutId);
        } else {
          selectModule();
        }
      }
      if (selectedCourse === "Full Course") {
        const moduleList = course.modules.map((module) => module.id);
        scrollToSection("top");
        const result = await dispatch(
          addToCart({ courseId: course.id, moduleList: moduleList }),
        );

        if (result.payload?.resultCode != 1) {
          callAlert("", result.payload?.message);

          return;
        }

        notify();
        const timeoutId = setTimeout(() => {
          navigate("/cart");
        }, 2000);
        return () => clearTimeout(timeoutId);
      }
    }
  };

  useEffect(() => {
    // Wait a moment to ensure DOM is rendered
  }, []);

  const handleAddToCartFreeTrial = async (id) => {
    navigate("/register", {
      state: {
        courseBoard: course?.board?.toLowerCase(), // "ICSE" → "icse"
        courseGrade: course?.grade?.toLowerCase(), // "Class 9" → "class 9"
      },
    });
    setTrailDetails({
      modeClass: id,
    });
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>Sign up first</strong>
        </>,
        { theme: "colored" },
      );

      // return;
    } else {
      subscriptionTrial((d) => {
        navigate(`/user/dashboard`, {});
      });
    }
  };

  return (
    <>
      {course && (
        <Helmet>
          <title>{course.courseName + " | EFH Online Computer Science Tuition"}</title>
          <meta
            name="description"
            content={"Learn " + course.courseName + " online with EFH. Expert Computer Science tuition for ICSE and CBSE students of Class 9-12. Start your free trial today."}
          />
          <link rel="canonical" href={"https://efhonline.com/course-details/" + id} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="EFH - Education From Home" />
          <meta property="og:title" content={course.courseName + " | EFH Online Computer Science Tuition"} />
          <meta property="og:description" content={"Learn " + course.courseName + " online with EFH. Expert Computer Science tuition for ICSE and CBSE students."} />
          <meta property="og:url" content={"https://efhonline.com/course-details/" + id} />
          <meta property="og:image" content="https://efhonline.com/logo.png" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={course.courseName + " | EFH Online Computer Science Tuition"} />
          <meta name="twitter:description" content={"Learn " + course.courseName + " online with EFH."} />
          <meta name="twitter:image" content="https://efhonline.com/logo.png" />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Course",
              name: course.courseName,
              description: course.summary || course.courseName,
              provider: {
                "@type": "Organization",
                name: "EFH - Education From Home",
                sameAs: "https://efhonline.com",
              },
            })}
          </script>
        </Helmet>
      )}
      {loader && (
        // <div className="m-4 p-4">
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "white", // Prevents seeing the footer behind the loader
          }}
        >
          {/* <Loader /> */}
          <PageLoader />
        </div>
      )}
      {!loader && (
        <>
          <div className="course-details-page">
            <TrainingCourseBanner
              name={course?.courseName}
              summary={course.summary}
              price={course.price}
              discount={course.discount}
              course={course}
              userDetails={userDetailss}
              handleAddToCartFreeTrial={handleAddToCartFreeTrial}
              ratings={"275"}
              notify={notify}
              // course={course}
            />
            <div>
              <Container>
                <Row>
                  <Col sm={12}>
                    <style>{`
      .course-text-content,
      .course-text-content * {
        font-size: 16px !important;
        color: #333333 !important;
      }
    `}</style>
                    <div className="course-page-content">
                      <h2 className="key-highlight-title">
                        Course <span>Highlight</span>{" "}
                      </h2>
                      <div className="">
                        {course.description !== null ?
                          <>
                            <div
                              className="key-highlights course-text-content"
                              style={{ marginBottom: "-25px" }}
                            >
                              {course.description.map((item, index) => (
                                <>{parse(String(item.head))}</>
                              ))}
                            </div>
                          </>
                        : <></>}

                        <Row className="pt-5">
                          <Col lg={12}>
                            <Row>
                              <Col md={12}>
                                {course.summary !== "" ?
                                  <>
                                    <h2
                                      className="key-highlight-title"
                                      id="course-details"
                                    >
                                      Course <span>Overview</span>
                                    </h2>
                                    <div className="course-text-content">
                                      {course.description.map((item, index) => (
                                        <>{parse(String(item.para))}</>
                                      ))}
                                    </div>
                                  </>
                                : <></>}

                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch mb-3 mt-3">
                                  <div className="col-12 col-md-8 d-flex flex-column flex-md-row gap-2 mb-3 mt-3 ">
                                    <button
                                      type="button"
                                      className={`btn ${
                                        selectedCourse == "Full Course" ?
                                          "btn-primary"
                                        : "btn-outline-primary"
                                      } btn-lg`}
                                      onClick={handleCourseChange}
                                      value="Full Course"
                                    >
                                      {" "}
                                      Full Course (₹{course.price}){" "}
                                    </button>

                                    <button
                                      type="button"
                                      className={`btn ${
                                        selectedCourse == "Custom Course" ?
                                          "btn-primary"
                                        : "btn-outline-primary"
                                      } btn-lg`}
                                      onClick={handleCourseChange}
                                      value="Custom Course"
                                    >
                                      {" "}
                                      Custom Modules{" "}
                                    </button>

                                    <select
                                      className="btn btn-primary form-select form-select-lg btn-lg hide"
                                      value={selectedCourse}
                                    >
                                      <option selected value="Custom Course">
                                        Custom Course
                                      </option>
                                      <option value="Full Course">
                                        Full Course ({course.price})
                                      </option>
                                    </select>
                                  </div>
                                  <div className="col-12 col-md-3 d-grid mb-3 mt-3">
                                    {userDetailss ?
                                      <button
                                        className="btn btn-primary btn-lg"
                                        title=" Add to cart"
                                        onClick={handleAddToCart}
                                      >
                                        <span className="mx-2">
                                          Add to cart{" "}
                                        </span>
                                        <FaCartArrowDown />
                                      </button>
                                    : <button
                                        className="btn btn-primary btn-lg"
                                        title=" Add to cart"
                                        onClick={handleAddToCart}
                                        data-bs-toggle="modal"
                                        data-bs-target="#loginModal"
                                      >
                                        <span className="mx-2">
                                          Add to cart
                                        </span>
                                        <FaCartArrowDown />
                                      </button>
                                    }
                                  </div>
                                </div>

                                {selectedCourse === "Custom Course" && (
                                  <div className=" border pt-2 px-2 d-flex mt-2 justify-content-between align-item-center">
                                    <h5 className="modprice">
                                      Selected Modules: {selectedCount}
                                    </h5>
                                    {totalPrice > 0 ?
                                      <h5 className="modprice">
                                        Total: ₹{totalPrice}
                                      </h5>
                                    : <></>}
                                  </div>
                                )}

                                <div className="accordion-wrapper mb-2">
                                  <AccordionComponent
                                    courseModule={course.moduleList}
                                    selectedCourse={selectedCourse}
                                    setCustomModuleList={setCustomModuleList}
                                    setTotalPrice={setTotalPrice}
                                    setSelectedCount={setSelectedCount}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div className="course-page-content">
                      <h2 className="key-highlight-title pt-4">
                        Customer <span>Reviews </span>{" "}
                        <span className="review-count">
                          ( {ratings.length} )
                        </span>
                      </h2>

                      <Row>
                        {/* Map over the ratings array, but only up to the number of visible items */}
                        {ratings.slice(0, visibleItems).map((rating, index) => (
                          <Col key={index} md={4} className="mb-3">
                            <ReviewCard rating={rating} />
                          </Col>
                        ))}
                      </Row>
                      {/* Show "View More" button if there are more items to load */}
                      {visibleItems < ratings.length && (
                        <Row>
                          <div className="col-md-4 offset-md-4 mt-3">
                            <div className="text-center d-grid ">
                              <button
                                className="btn btn-primary btn-lg"
                                onClick={loadMoreItems}
                              >
                                View More <FaAngleDown />
                              </button>
                            </div>
                          </div>
                        </Row>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div className="course-page-content">
                      <h2 className="key-highlight-title pt-4">
                        Related <span>Courses</span>
                      </h2>

                      {courses.length === 0 ?
                        <Loader />
                      : <CourseSlider dataCourse={courses} />}
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row>
                  <Col></Col>
                </Row>
              </Container>
            </div>
          </div>

          {/* <div className="footercta">
        <Container>
          <Row>
            <Col>
              <CTA />
            </Col>
          </Row>
        </Container>
      </div> */}
        </>
      )}
    </>
  );
}
